import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import { FlexWrap } from 'modules/Roles/NewRoleCreation/Partials/SelectCollegesDrawer/Style/style.js'
import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { Spin } from 'antd'
import ReactDOMServer from 'react-dom/server'
import { useSelector, useDispatch } from 'react-redux'
import RoleDetailsToTPOTemplate from 'components/EmailTemplate/RoleDetailsToTPOTemplate'
import RoleShareToTPOTemplate from 'components/EmailTemplate/RoleShareToTPOTemplate'
import LoadingOverlay from 'modules/CorporateDashboardPage2/Container/components/LoadingOverlay'
import {
  buildJobDetailsTable,
  formatApplicationDeadline,
} from 'utils/jobDetailsTable'
import {
  getRoleData,
  getRoleLinks,
  updateRoleLinksEmailSent,
} from 'modules/RoleLinks/actions'
import { sendNotificationBulkEmail, sendNotificationBulkEmailWhatsapp } from 'modules/Users/actions'
import CustomModal from './CustomModal'
import GroupCreation from './Partials/GroupCreation'
import GroupCollegeDrawer from './Partials/GroupCollegeDrawer'
import TierDrawer from 'components/UIComponents/TierDrawer'
import POCDetailsDrawer from 'components/UIComponents/POCDetailsDrawer'
import AddToGroupDrawer from 'components/UIComponents/AddToGroupDrawer'
import CloseRoleDrawer from 'components/CloseRolePopup'
import ApprovedModelIcon from 'components/icons/ApprovedModelIcon'
import { POPUP_CONFIGS } from 'utils/const'
import RedPopUp from 'components/icons/RedPopup'
import SelectedCollegesDrawer from './SelectedCollegesDrawer'
import PublishedCollegesDrawer from './PublishedCollegesDrawer'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { useNavigate } from 'react-router-dom'

const SelectCollegesDrawer = ({
  jobId,
  collegeDrawer,
  setCollegeDrawer,
  setPreviewDrawer,
  selectedInstituteData,
  onClickSelect,
  onPublishRole,
  instituteError,
  previewRoleData,
  getInstitutesList,
  getInstitutesLocationList,
  institutesList,
  getJobRoleCampusList,
  isEditRoleOnView,
  selectedCollegeCount,
  setSelectedCollegeCount,
  roleFormData,
  institutesLocationList,
  createGroup,
  updateGroup,
  deleteGroup,
  oneGroupDetail,
  removeInstituteFromGroup,
  viewGroupCollege,
  setviewGroupCollege,
  getMatchedInstituteList,
  instituteGroupList,
  createDraftSelectInstitute,
  getSelectedInstitutes,
  updateCorporateInstituteDetails,
  createCorporateInstituteDetails,
  dublicateGroup,
  getMatchedInstituteListFilter,
  groupInstituteListFilter,
  getSelectedInstitutesFilter,
  getMapMetrics,
  publishRole,
  deleteSelectedDraftInstitute,
  roleData,
  degreeStreamMapIds,
}) => {
  const dispatch = useDispatch()
  const userData = useSelector(state => state.auth.userData)
  const corporateData = useSelector(state => state.auth.corporateData)
  const [collagesRadio, setCollagesRadio] = useState('Select Collages')
  const [groupName, setGroupName] = useState('')
  const [groupId, setGroupId] = useState('')
  const [groupDetails, setGroupDetails] = useState('')
  const [mapMetrics, setMapMetrics] = useState({})
  const [chartMetrics, setChartMetrics] = useState([])
  const [selectedInstitute, setSelectedInstitute] = useState([])
  const [instituteCampusList, setInstituteCampusList] = useState([])
  const [groupsInstituteCampusIds, setGroupsInstituteCampusIds] = useState([])
  const [listData, setListData] = useState([])
  const [pageNo, setPageNo] = useState(0)
  const [publishedCampusList, setPublishedCampusList] = useState([])
  const [publishedDrawerOpen, setPublishedDrawerOpen] = useState(false)
  // IDs of colleges this role is ALREADY published to (edit/republish mode).
  // Derived from getRoleLinks; used to pre-select + lock those table rows and
  // to keep them out of the republish payload.
  const publishedIds = useMemo(
    () => publishedCampusList.map(c => c.instituteCampusId),
    [publishedCampusList]
  )
  const publishedIdSet = useMemo(() => new Set(publishedIds), [publishedIds])
  const [instituteLocationList, setInstituteLocationList] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [locationValue, setLocationValue] = useState([])
  const [tierValue, setTierValue] = useState([])
  const [collegesFilterData, setCollegesFilterData] = useState({
    location: [],
    tier: [],
  })
  const [groupBackup, setGroupBackup] = useState({})

  const [tierDrawerOpen, setTierDrawerOpen] = useState(false)
  const [editTier, setEditTier] = useState(null)
  const [editingRecord, setEditindRecord] = useState({})
  const [pocList, setPocList] = useState([])
  const [fromGroup, setFromGroup] = useState([])
  const [pocDrawerOpen, setPocDrawerOpen] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [groupCreationDrawerVisible, setGroupCreationDrawerVisible] =
    useState(false)
  const [addToGroupDrawerOpen, setAddToGroupDrawerOpen] = useState(false)
  const [selectedCollegesDrawerOpen, setSelectedCollegesDrawerOpen] =
    useState(false)
  const [addToGroupMode, setAddToGroupMode] = useState('new')
  const [selectedExistingGroup, setSelectedExistingGroup] = useState(null)
  const [collegeData, setCollegeData] = useState([])
  const [groupData, setGroupData] = useState([])
  const [totalCollegeCount, setTotalCollegeCount] = useState(0)
  const [groupCount, setGroupCount] = useState(0)
  const [popupConfig, setPopupConfig] = useState(null)
  const [pocEditingIndex, setPocEditingIndex] = useState(null)

  const navigate = useNavigate()
  const openModal = () => {
    setModalVisible(false)
  }
  const closeModal = () => {
    setModalVisible(false)
  }
  const handleEditTier = (record, fromGroup) => {
    if (record?.pocDetails?.length > 0) {
      setFromGroup(fromGroup)
    } else {
      setFromGroup(fromGroup)
    }
    setEditindRecord(record)
    setEditTier(record.tier)
    setTierDrawerOpen(true)
  }
  const handleAddPOC = () => {
    setPocDrawerOpen(true)
  }
  const handleEditPOC = (record, fromGroup) => {
    setEditindRecord(record)
    if (record?.pocDetails?.length > 0) {
      setPocList(record?.pocDetails)
      setFromGroup(fromGroup)
    } else {
      setPocList([])
      setFromGroup(fromGroup)
    }
    setPocEditingIndex(null)
    setPocDrawerOpen(true)
  }
  const handleSavePOC = ({ poc, index, action }) => {
    setPocList(prev => {
      let newList = [...prev]
      if (action === 'add') {
        if (poc.isPrimary)
          newList = newList.map(p => ({ ...p, isPrimary: false }))
        newList.push(poc)
      } else if (action === 'update') {
        if (poc.isPrimary) {
          newList = newList.map((p, i) =>
            i === index ? p : { ...p, isPrimary: false }
          )
        }
        newList[index] = poc
      } else if (action === 'delete') {
        newList.splice(index, 1)
      }
      return newList
    })
    setPocEditingIndex(null)
    // setPocDrawerOpen(false);
  }

  const handleCancelPOC = () => {
    setPocEditingIndex(null)
    setPocDrawerOpen(false)
  }

  const [pageNum, setPageNum] = useState(1) // 1-based for UI
  const [pageLimit, setPageLimit] = useState(10)
  const [loading, setLoading] = useState(false)
  const [publishLoading, setPublishLoading] = useState(false)
  const [filterData, setFilterData] = useState({
    states: [],
    cities: [],
  })
  const [groupInstFilterData, setGroupInstFilterData] = useState({
    states: [],
    cities: [],
  })
  const [selectedFilterData, setSelectedFilterData] = useState({
    states: [],
    cities: [],
  })
  const [selectedCollegeFilters, setSelectedCollegeFilters] = useState({
    selectedTiers: [],
    selectedStates: [],
    selectedCities: [],
    pilRecommended: false,
    search: '',
    sort: '',
    orderBy: '',
  })

  useEffect(() => {
    fetchCollegeList(1, 10, true, {}, '')
  }, [degreeStreamMapIds])

  // Load the colleges this role is already published to so we can show the
  // banner, lock those rows, and exclude them from the republish payload.
  // Data-driven (not gated on the volatile isEditRoleOnView redux flag, which
  // resets on refresh): an empty result simply means "first-time publish".
  // Reuses the existing role-links endpoint (no BE change).
  useEffect(() => {
    const fetchPublishedColleges = async () => {
      if (collegeDrawer && jobId) {
        try {
          const roleLinksData = await getRoleLinks(jobId, {
            pageNo: 0,
            pageLimit: 500,
          })
          setPublishedCampusList(roleLinksData?.result || [])
        } catch (e) {
          console.error('Error fetching already-published colleges:', e)
        }
      }
    }
    fetchPublishedColleges()
  }, [collegeDrawer, jobId])
  const [collegeSearch, setCollegeSearch] = useState('')
  const [debouncedCollegeSearch, setDebouncedCollegeSearch] = useState('')
  const [currentGroupSearch, setCurrentGroupSearch] = useState('')

  // Debounced search effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedCollegeSearch(collegeSearch)
    }, 500) // 500ms delay

    return () => clearTimeout(timer)
  }, [collegeSearch])

  // Effect to trigger search when debounced value changes
  useEffect(() => {
    if (
      debouncedCollegeSearch !== undefined &&
      debouncedCollegeSearch !== null
    ) {
      fetchCollegeList(
        1,
        pageLimit,
        setLoading,
        collegeFilters,
        debouncedCollegeSearch
      )
    }
  }, [debouncedCollegeSearch])

  const fetchCollegeList = async (
    page = pageNum,
    limit = pageLimit,
    updateFilterData = true,
    filters = collegeFilters,
    search = debouncedCollegeSearch || collegeSearch
  ) => {
    try {
      setLoading(true)
      const payload = {
        pageLimit: limit,
        pageNo: page, // backend is 0-based
        degreeStreamMaps: degreeStreamMapIds,
        stateId: filters.selectedStates,
        cityId: filters.selectedCities,
        tier: filters.selectedTiers,
        search: search || '',
        sort: filters?.sort || '',
        orderBy: filters?.orderBy || '',
        ...(filters.pilRecommended ? { pilRecommended: true } : {}),
      }

      const collegeList = await getMatchedInstituteList(payload)
      // Only update filterData if requested
      if (updateFilterData) {
        try {
          const filterResponse = await getMatchedInstituteListFilter(payload)
          setFilterData({
            states: filterResponse?.states || [],
            cities: filterResponse?.cities || [],
          })
        } catch (error) {
          console.error('Error fetching filter data:', error)
        }
      }
      setPageNum(page)
      setPageLimit(limit)
      const pagination = collegeList?.pagination
      setCollegeData(collegeList?.result)
      setTotalCollegeCount(pagination?.totalItems || 0)
    } catch (e) {
      console.error('Error fetching college list:', e)
    } finally {
      setLoading(false)
    }
  }
  const fetchGroupList = async (
    search = '',
    pageNo = 1,
    pageLimit = 10,
    allGroups
  ) => {
    // Store the current search value for pagination
    setCurrentGroupSearch(search)
    try {
      setLoading(true)
      const groupList = await instituteGroupList({
        search,
        pageNo,
        pageLimit,
        allGroups,
      })
      const pagination = groupList?.pagination
      setGroupData(groupList?.result)
      setGroupCount(pagination?.totalItems || 0)
      setSelectedGroupPagination(pagination)
    } catch (e) {
      console.error('Error fetching group list:', e)
    } finally {
      setLoading(false)
    }
  }
  const handlePublish = () => {
    onPublishRole(collagesRadio)
  }
  const fetchGroupDetails = async (
    options = {},
    pageNo = 1,
    pageLimit = 10,
    sortParams = {}
  ) => {
    try {
      setLoading(true)
      // The filter dropdown stores state/city by NAME (its option value), but the
      // group-detail API filters on state_id/city_id. Translate name -> id using the
      // group's filter options before sending. Fall back to the raw value if a match
      // isn't found (e.g. it's already an id), so the filter never silently no-ops.
      const stateNameToId = new Map(
        (groupInstFilterData?.states || []).map(s => [s.state, s.stateId])
      )
      const cityNameToId = new Map(
        (groupInstFilterData?.cities || []).map(c => [c.city, c.cityId])
      )
      const selectedStateIds = (groupInstListSelectedFilter.selectedStates || [])
        .map(v => stateNameToId.get(v) ?? v)
        .filter(Boolean)
      const selectedCityIds = (groupInstListSelectedFilter.selectedCities || [])
        .map(v => cityNameToId.get(v) ?? v)
        .filter(Boolean)
      const payload = {
        pageNo,
        pageLimit,
        groupId,
        ...(selectedStateIds.length
          ? { stateId: selectedStateIds.join(',') }
          : {}),
        ...(selectedCityIds.length
          ? { cityId: selectedCityIds.join(',') }
          : {}),
        ...(groupInstListSelectedFilter.selectedTiers?.length
          ? { tier: groupInstListSelectedFilter.selectedTiers.join(',') }
          : {}),
        ...(groupInstListSelectedFilter.pilRecommended
          ? { pilRecommended: true }
          : {}),
        search: groupInstListSelectedFilter?.search,
        ...(sortParams.sort ? { sort: sortParams.sort } : {}),
        ...(sortParams.orderBy ? { orderBy: sortParams.orderBy } : {}),
      }

      const groupDetailResponse = await oneGroupDetail(payload)
      const groupDetail = groupDetailResponse?.result
      const groupInstitutePagination = groupDetailResponse?.pagination
      setGroupDetails(groupDetail)
      // Fetch group filter data (states, cities) from API only if not triggered from filter
      if (groupId && !options.triggerFromFilter) {
        try {
          const filterResp = await groupInstituteListFilter(groupId)

          if (filterResp) {
            setGroupInstFilterData(prev => ({
              ...prev,
              states: filterResp.states || [],
              cities: filterResp.cities || [],
            }))
          }
        } catch (e) {
          setGroupInstFilterData(prev => ({
            ...prev,
            states: [],
            cities: [],
          }))
        }
        setGroupInstListSelectedFilter(prev => ({
          ...prev,
          selectedStates: prev?.selectedStates || [],
          selectedCities: prev?.selectedCities || [],
          selectedTiers: prev?.selectedTiers || [],
          pilRecommended: prev?.pilRecommended || false,
          search: prev.search || '',
        }))
      }
      if (groupDetail?.groupName) {
        setGroupName(groupDetail.groupName)
      }

      setInstituteCampusList(groupDetail.instituteCampusList || [])
      setSelectedGroupInstitutePagination(groupInstitutePagination)
      setGroupBackup(groupDetail)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching group details:', error)
      setLoading(false)
    }
  }
  const fetchMapMetrics = async (groupId, forAllCollege) => {
    const mapMetrics = await getMapMetrics({
      groupId,
      forAllCollege,
      degreeStreamMap: degreeStreamMapIds,
    })

    setMapMetrics(mapMetrics?.state)
    setChartMetrics(mapMetrics?.tier)
  }
  const onAddGroup = async () => {
    if (groupId) {
      fetchGroupDetails({}, selectedGroupInstitutePagination?.currentPage)
    }
    setGroupCreationDrawerVisible(true)
  }
  const [selectedGroupPagination, setSelectedGroupPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  })
  const [
    selectedGroupInstitutePagination,
    setSelectedGroupInstitutePagination,
  ] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  })
  const closeHandler = () => {
    setCollegeDrawer(false)
    setCollagesRadio('Select Collages')
    setListData([])
    setPageNo(0)
    setSearchValue('')
    setPublishedCampusList([])
    setCollegesFilterData({
      location: [],
      tier: '',
    })
    setLocationValue([])
    setInstituteLocationList([])
    setTierValue([])
  }
  const handleAddToGroup = record => {
    if (record) {
      handleCollegeSelectChange([record?.instituteCampusId], [record])
    }
    setAddToGroupDrawerOpen(true)
    setAddToGroupMode('new')
    setSelectedExistingGroup(null)
  }

  const handleAddToExistingGroup = group => {
    setAddToGroupDrawerOpen(false)
    showRemoveInstitutePopup(false)
  }
  const handleCreateNewGroup = (fromGroup = false) => {
    return new Promise(resolve => {
      setPopupConfig({
        ...POPUP_CONFIGS.CREATE_NEW_GROUP,
        description: (
          <span>
            Are you sure you want to <b>Create a new group</b>?
          </span>
        ),
        icon: ApprovedModelIcon,
        onApprove: async () => {
          if (fromGroup) {
            const payload = []
            await createDraftSelectInstitute(payload)
          }
          setGroupCreationDrawerVisible(true)
        },
        onClose: () => {
          setPopupConfig(null)
          resolve()
        },
      })
    })
  }

  // Group table handlers
  const handleAdd = record => {
    console.log('Add clicked', record)
  }
  const handleDelete = record => {
    console.log('Delete clicked', record)
  }
  const handleEdit = record => {
    setGroupId(record?.id)
    setGroupCreationDrawerVisible(true)
  }
  const handleAddQueue = record => {
    console.log('Duplicate clicked', record)
  }

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedGroupIds(selectedRowKeys)
  }
  const onPageChange = (...args) => {
    console.log('Page change', ...args)
  }
  const [selectedColleges, setSelectedColleges] = useState([])
  const [selectedCollegeIds, setSelectedCollegeIds] = useState([])
  const [selectedGroupIds, setSelectedGroupIds] = useState([])
  const [selectedInstitutesData, setSelectedInstitutesData] = useState([])
  const [selectedInstitutesIds, setSelectedInstitutesIds] = useState([])
  const [selectedInstitutesPagination, setSelectedInstitutesPagination] =
    useState({
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 1,
    })
  const [selectedDraftLoading, setSelectedDraftLoading] = useState(false)

  const handleCollegeSelectChange = (selectedRowKeys, selectedRows) => {
    // Update selectedCollegeIds to persist across pages
    setSelectedCollegeIds(prevIds => {
      // Remove unchecked
      const filtered = prevIds.filter(id => selectedRowKeys.includes(id))
      // Add new checked (avoid duplicates)
      const newChecked = selectedRowKeys.filter(id => !filtered.includes(id))
      return [...filtered, ...newChecked]
    })

    // Update selectedColleges to persist across pages
    setSelectedColleges(prevRows => {
      // Remove unchecked
      const filtered = prevRows.filter(row =>
        selectedRowKeys.includes(row.instituteCampusId)
      )
      // Add new rows (avoid duplicates)
      const newRows = selectedRows.filter(
        row =>
          !filtered.some(r => r.instituteCampusId === row.instituteCampusId)
      )
      return [...filtered, ...newRows]
    })
  }

  // Handler for single row select
  const handleSingleRowSelect = (record, selected) => {
    setSelectedCollegeIds(prev => {
      if (selected) {
        return prev.includes(record.instituteCampusId)
          ? prev
          : [...prev, record.instituteCampusId]
      } else {
        return prev.filter(id => id !== record.instituteCampusId)
      }
    })

    setSelectedColleges(prev => {
      if (selected) {
        return prev.some(r => r.instituteCampusId === record.instituteCampusId)
          ? prev
          : [...prev, record]
      } else {
        return prev.filter(
          r => r.instituteCampusId !== record.instituteCampusId
        )
      }
    })
  }

  // Handler for select all on page
  const handleSelectAllRows = (selected, selectedRows, changeRows) => {
    const changeIds = changeRows.map(r => r.instituteCampusId)
    setSelectedCollegeIds(prev => {
      if (selected) {
        return Array.from(new Set([...prev, ...changeIds]))
      } else {
        return prev.filter(id => !changeIds.includes(id))
      }
    })

    setSelectedColleges(prev => {
      if (selected) {
        const newRows = changeRows.filter(
          r => !prev.some(pr => pr.instituteCampusId === r.instituteCampusId)
        )
        return [...prev, ...newRows]
      } else {
        return prev.filter(r => !changeIds.includes(r.instituteCampusId))
      }
    })
  }
  const handlePageChange = (from, newPage, newPageSize) => {
    if (from == 'college') {
      setPageNum(newPage)
      setPageLimit(newPageSize)
      fetchCollegeList(newPage, newPageSize, setLoading)
    } else if (from == 'group') {
      // Preserve the current search value when changing pages
      fetchGroupList(currentGroupSearch, newPage, newPageSize)
    } else if (from == 'groupInstitute') {
      if (!groupId) {
        getDraftSelectList(
          newPage,
          newPageSize,
          true,
          groupInstListSelectedFilter
        )
      } else {
        fetchGroupDetails({}, newPage, newPageSize)
      }
    } else if (from == 'draftSelect') {
      getDraftSelectList(newPage, newPageSize)
    } else if (from == 'addToGroup') {
      fetchAddToGroupColleges(newPage, newPageSize)
    }
  }
  const handleSort = (from, newPage, newPageSize, sort = '', orderBy = '') => {
    if (from == 'college') {
      setPageNum(newPage)
      setPageLimit(newPageSize)
      fetchCollegeList(newPage, newPageSize, setLoading, {
        ...collegeFilters,
        orderBy,
        sort,
      })
    }
  }

  // Enhanced sort handler for table columns with proper orderBy logic
  const handleTableSort = (pagination, filters, sorter, from) => {
    const { field, order } = sorter

    // if (field && order) {
    let orderBy = ''
    let sort = ''

    // Map field names to API parameters
    switch (field) {
      case 'tier':
        sort = 'tier'
        break
      case 'collegeName':
        sort = 'collegeName'
        break
      case 'location':
        sort = 'city'
        break
      default:
        sort = field
    }

    // Map order to sort parameter (asc, desc, or empty for none)
    switch (order) {
      case 'ascend':
        orderBy = 'asc'
        break
      case 'descend':
        orderBy = 'desc'
        break
      default:
        orderBy = ''
        sort = ''
    }

    // Update filters based on table type
    if (from === 'college') {
      setCollegeFilters({
        ...collegeFilters,
        orderBy,
        sort,
      })
      // Call handleSort with the proper payload structure
      handleSort('college', pageNum, pageLimit, sort, orderBy)
    } else if (from === 'groupInstitute') {
      // Handle group institute sorting
      if (groupId) {
        setGroupInstListSelectedFilter({
          ...groupInstListSelectedFilter,
          sort,
          orderBy,
        })
        fetchGroupDetails({}, pageNum, pageLimit, { sort, orderBy })
      } else {
        setGroupInstListSelectedFilter({
          ...groupInstListSelectedFilter,
          sort,
          orderBy,
        })
        getDraftSelectList(pageNum, pageLimit, true, {
          ...groupInstListSelectedFilter,
          sort,
          orderBy,
        })
      }
    } else if (from === 'draftSelect') {
      setSelectedCollegeFilters({
        ...selectedCollegeFilters,
        sort,
        orderBy,
      })
      // Handle draft select sorting
      getDraftSelectList(pageNum, pageLimit, false, {
        ...selectedCollegeFilters,
        sort,
        orderBy,
      })
    } else if (from === 'addToGroup') {
      // Handle add to group sorting
      fetchAddToGroupColleges(pageNum, pageLimit, false, {
        ...selectedCollegeFilters,
        sort,
        orderBy,
      })
    }
    // }
  }
  const getDraftSelectList = async (
    pageNo = 1,
    pageLimit = 10,
    fromNewGroup = false,
    filters = {},
    sortParams = {},
    passFilters = true,
  ) => {
    try {
      if (!fromNewGroup) setSelectedDraftLoading(true)
      const selectedInstitutesResponse = await getSelectedInstitutes({
        ...(passFilters ? selectedCollegeFilters : {}),
        ...filters,
        pageLimit: pageLimit,
        pageNo: pageNo,
        ...(sortParams.sort ? { sort: sortParams.sort } : {}),
        ...(sortParams.orderBy ? { orderBy: sortParams.orderBy } : {}),
      })

      setSelectedInstitutesData(selectedInstitutesResponse.result || [])
      setInstituteCampusList(selectedInstitutesResponse.result || [])
      setSelectedInstitutesPagination(
        selectedInstitutesResponse.pagination || {
          currentPage: 1,
          pageSize: pageLimit,
          totalItems: 0,
          totalPages: 1,
        }
      )
      setSelectedGroupInstitutePagination(selectedInstitutesResponse.pagination)
    } finally {
      if (!fromNewGroup) setSelectedDraftLoading(false)
    }
  }
  // Handler for View Selected colleges button
  const handleViewSelectedColleges = async (
    fromNewGroup = false,
    mergedCollegesArg = [],
    forDelete = false
  ) => {
    // Prepare payload from mergedColleges
    const collegesToUse =
      forDelete || mergedCollegesArg?.length
        ? mergedCollegesArg
        : selectedColleges

    const payload = collegesToUse.map(college => ({
      instituteCampusId: college.instituteCampusId,
      tier: college.tier,
      pocDetails: college.pocDetails || [],
    }))

    try {
      await createDraftSelectInstitute(payload)
      // Fetch filter data for selected colleges
      const filterResp = await getSelectedInstitutesFilter()

      if (filterResp) {
        if (fromNewGroup) {
          if (!forDelete) {
            const collegesToUseIds = collegesToUse?.map(item => item?.instituteCampusId)
            setSelectedCollegeIds(collegesToUseIds)
            setGroupsInstituteCampusIds(collegesToUseIds)
          }
          setGroupInstFilterData({
            ...groupInstFilterData,
            states: filterResp.states || [],
            cities: filterResp.cities || [],
          })
        } else {
          setSelectedDrawerFilterData({
            ...selectedDrawerFilterData,
            states: filterResp.states || [],
            cities: filterResp.cities || [],
          })
        }
      }
      // After creating draft, fetch selected institutes
      await getDraftSelectList(1, 10, fromNewGroup,{},{},false)
      if (!forDelete) {
        if (!fromNewGroup) {
          setSelectedCollegesDrawerOpen(true) // Open the drawer after API call
        } else {
          setSelectedCollegesDrawerOpen(false) // Open the drawer after API call
        }
      }
      await fetchMapMetrics()
    } catch (error) {
      console.error('API error:', error)
    }
  }
  const handleAddToNewGroup = async () => {
    // Merge selectedColleges and selectedToAdd, avoiding duplicates
    const combined = [
      ...(selectedColleges || []),
      ...(addToGroupSelectedData || []),
    ]

    // Remove duplicates by instituteCampusId
    const uniqueColleges = Array.from(
      new Map(combined.map(item => [item.instituteCampusId, item])).values()
    )
    console.log(uniqueColleges," :uniqueColleges",selectedColleges,addToGroupSelectedIds)
    setSelectedColleges(uniqueColleges)
    handleViewSelectedColleges(true, uniqueColleges)
  }
  const handleCloseSelectedCollegesDrawer = async () => {
    setSelectedCollegesDrawerOpen(false)
    setSelectedCollegesDrawerMode('default')
    await fetchMapMetrics(groupId)

    // Reset filters to default state when drawer is closed
    setSelectedCollegeFilters({
      selectedTiers: [],
      selectedStates: [],
      selectedCities: [],
      pilRecommended: false,
      search: '',
    })
  }

  const handleTabChange = tab => {
    if (tab === 'colleges') {
      // Clear college-related state
      setCollegeData([])
      setSelectedColleges([])
      setSelectedCollegeIds([])
      setPageNum(1)
      setPageLimit(10)
      setCollegeFilters({
        selectedTiers: [],
        selectedStates: [],
        selectedCities: [],
        pilRecommended: false,
        orderBy: '',
        sort: '',
      })
      setCollegeSearch('')
      fetchCollegeList(
        1,
        10,
        setLoading,
        {
          selectedTiers: [],
          selectedStates: [],
          selectedCities: [],
          pilRecommended: false,
        },
        false,
        ''
      )
      setSelectedGroupIds([])
    } else if (tab === 'groups') {
      // Clear group-related state
      setGroupData([])
      setSelectedGroupPagination({
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 1,
      })
      setCurrentGroupSearch('') // Reset group search when switching to groups tab
      setCollegeFilters({
        selectedTiers: [],
        selectedStates: [],
        selectedCities: [],
        pilRecommended: false,
        orderBy: '',
        sort: '',
      })
      setCollegeSearch('')
      fetchGroupList()
      setSelectedColleges([])
      setSelectedGroupIds([])
      setSelectedCollegeIds([])
    }
  }

  const content = () => {
    return (
      <GroupCollegeDrawer
        handlePublishRole={handlePublishRole}
        handleSkip={handleSkip}
        publishedIds={publishedIds}
        publishedCount={publishedCampusList.length}
        isRepublishMode={publishedCampusList.length > 0}
        onViewPublished={() => setPublishedDrawerOpen(true)}
        selectedGroupIds={selectedGroupIds}
        setSelectedGroupIds={setSelectedGroupIds}
        handleCreateNewGroup={handleCreateNewGroup}
        viewGroupCollege={collegeDrawer}
        setviewGroupCollege={setCollegeDrawer}
        onClickSelect={onClickSelect}
        onPublishRole={onPublishRole}
        instituteError={instituteError}
        singleRoleData={roleData}
        previewRoleData={previewRoleData}
        getInstitutesList={getInstitutesList}
        getInstitutesLocationList={getInstitutesLocationList}
        institutesList={institutesList}
        getJobRoleCampusList={getJobRoleCampusList}
        isEditRoleOnView={isEditRoleOnView}
        roleFormData={roleFormData}
        institutesLocationList={institutesLocationList}
        createGroup={createGroup}
        updateGroup={updateGroup}
        deleteGroup={deleteGroup}
        oneGroupDetail={oneGroupDetail}
        removeInstituteFromGroup={removeInstituteFromGroup}
        groupName={groupName}
        setGroupName={setGroupName}
        groupId={groupId}
        setGroupId={setGroupId}
        groupDetails={groupDetails}
        setGroupDetails={setGroupDetails}
        selectedInstitute={selectedInstitute}
        setSelectedInstitute={setSelectedInstitute}
        instituteCampusList={instituteCampusList}
        setInstituteCampusList={setInstituteCampusList}
        onAddGroup={onAddGroup}
        closeHandler={closeHandler}
        getMatchedInstituteList={getMatchedInstituteList}
        setGroupCreationDrawerVisible={setGroupCreationDrawerVisible}
        groupCreationDrawerVisible={groupCreationDrawerVisible}
        instituteGroupList={instituteGroupList}
        handleEditTier={handleEditTier}
        pocList={pocList}
        handleAddPOC={handleAddPOC}
        handleEditPOC={handleEditPOC}
        handleAddToGroup={handleAddToGroup}
        groupCount={groupCount}
        groupData={groupData}
        setCollegeData={setCollegeData}
        setGroupCount={setGroupCount}
        setGroupData={setGroupData}
        setTotalCollegeCount={setTotalCollegeCount}
        collegeData={collegeData}
        totalCollegeCount={totalCollegeCount}
        fetchCollegeList={fetchCollegeList}
        fetchGroupList={fetchGroupList}
        handleAdd={handleAdd}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        handleAddQueue={handleAddQueue}
        handleSort={handleTableSort}
        onSelectChange={onSelectChange}
        onPageChange={handlePageChange}
        showDeleteGroupPopup={showDeleteGroupPopup}
        showDuplicatePopup={showDuplicatePopup}
        selectedColleges={selectedColleges}
        setSelectedColleges={setSelectedColleges}
        onCollegeSelectChange={handleCollegeSelectChange}
        pageNum={pageNum}
        pageLimit={pageLimit}
        loading={loading}
        setLoading={setLoading}
        selectedCollegeIds={selectedCollegeIds}
        onSingleRowSelect={handleSingleRowSelect}
        onSelectAllRows={handleSelectAllRows}
        onViewSelectedColleges={handleViewSelectedColleges}
        selectedGroupPagination={selectedGroupPagination}
        onTabChange={handleTabChange}
        collegeFilters={collegeFilters}
        setCollegeFilters={setCollegeFilters}
        handleCollegeFilterChange={handleCollegeFilterChange}
        filterData={filterData}
        collegeSearch={collegeSearch}
        setCollegeSearch={handleCollegeSearchChange}
        currentGroupSearch={currentGroupSearch}
        // Pass state/city dropdown search/refresh props
        stateOptions={stateOptions}
        cityOptions={cityOptions}
        onStateSearch={handleStateSearch}
        onCitySearch={handleCitySearch}
        onStateDropdownClose={handleStateDropdownClose}
        onCityDropdownClose={handleCityDropdownClose}
      />
    )
  }

  // Edit/republish mode: let the user finalize without picking any new
  // college. No publish call, no new TPO notifications — already-published
  // colleges are untouched.
  const handleSkip = () => {
    setPopupConfig({
      ...POPUP_CONFIGS.CREATE_NEW_GROUP,
      description: (
        <span>
          You haven't selected any new college. Your role changes are saved, and
          the{' '}
          <b>
            {publishedCampusList.length}{' '}
            {publishedCampusList.length === 1 ? 'college' : 'colleges'} this role
            is already published to stay unchanged
          </b>
          . Do you want to continue?
        </span>
      ),
      icon: ApprovedModelIcon,
      onApprove: async () => {
        setPopupConfig(null)
        closeHandler()
        navigate('/rolePage')
      },
      onClose: () => setPopupConfig(null),
    })
  }

  const handlePublishRole = () => {
    return new Promise(resolve => {
      setPopupConfig({
        ...POPUP_CONFIGS.CREATE_NEW_GROUP,
        description: (
          <span>
            Are you sure you want to <b>send the role </b>to these colleges ?
          </span>
        ),
        icon: ApprovedModelIcon,
        onApprove: async () => {
          setPublishLoading(true)
          const payload = {
            groupIds: selectedGroupIds || [],
            degreeStreamMapIds: degreeStreamMapIds || [],
            // Exclude already-published colleges so we never re-float / re-send
            // TPO notifications to them on republish.
            instituteCampusIds: (selectedCollegeIds || []).filter(
              id => !publishedIdSet.has(id)
            ),
          }
          const publishRoleData = await publishRole(jobId, payload)
          if (
            publishRoleData?.message == 'Job Role Floated Institue Successfully'
          ) {
            setGroupCreationDrawerVisible(false)
            setCollegeDrawer(false)
            setAddToGroupDrawerOpen(false)
            setSelectedCollegesDrawerOpen(false)
            setPocDrawerOpen(false)
            setTierDrawerOpen(false)
            setPublishLoading(false)

            // Auto-send TPO emails after publish (fire and forget)
            try {
              const roleLinksData = await getRoleLinks(jobId, { pageNo: 0, pageLimit: 500 })
              if (roleLinksData?.result?.length) {
                const companyName = corporateData?.name || roleFormData?.corporateDetails?.companyName || 'Company'
                const userName = [userData?.first_name, userData?.last_name].filter(Boolean).join(' ')
                const userPhone = userData?.phone_number || ''

                // Track colleges we email so we can mark them email-sent.
                const emailedCampusIds = []
                const emailPayloads = []
                roleLinksData.result.forEach(college => {
                  if (college.tallyFormUrl && college.pocDetails?.length && !college.isEmailSent) {
                    const pocEmails = college.pocDetails
                      .map(poc => poc?.email)
                      .filter(Boolean)
                    if (pocEmails.length === 0) return

                    if (!emailedCampusIds.includes(college.instituteCampusId)) {
                      emailedCampusIds.push(college.instituteCampusId)
                    }
                    const htmlBody = ReactDOMServer.renderToString(
                      <RoleDetailsToTPOTemplate
                        data={{
                          companyName,
                          collegeName: college.campusName || 'College',
                          tallyLink: college.tallyFormUrl,
                          signatureName: userName,
                          signatureContact: userPhone,
                        }}
                      />
                    )
                    pocEmails.forEach(email => {
                      emailPayloads.push({
                        to: email,
                        subject: `Job Opportunity for Students - Application Form ${companyName}`,
                        htmlBody,
                      })
                    })
                  }
                })

                if (emailPayloads.length > 0) {
                  dispatch(sendNotificationBulkEmail(emailPayloads))
                }

                // WhatsApp to TPO POCs
                const whatsappPayloads = []
                roleLinksData.result.forEach(college => {
                  if (college.tallyFormUrl && college.pocDetails?.length && !college.isEmailSent) {
                    college.pocDetails.forEach(poc => {
                      if (poc?.number) {
                        whatsappPayloads.push({
                          to: poc.number,
                          templateName: 'corporate_role_share_tpo',
                          type: 'template',
                          components: [
                            {
                              type: 'BODY',
                              index: 0,
                              sub_type: 'CATALOG',
                              parameters: [
                                { type: 'TEXT', text: companyName },
                                { type: 'TEXT', text: college.campusName || 'College' },
                                { type: 'TEXT', text: college.tallyFormUrl },
                              ],
                            },
                          ],
                        })
                      }
                    })
                  }
                })
                if (whatsappPayloads.length > 0) {
                  dispatch(sendNotificationBulkEmailWhatsapp(whatsappPayloads))
                }

                // Job-details mail to the TPO of every college this publish
                // newly floated the role to. Separate from the application-form
                // mail above (which needs a tally link) — this one only needs
                // the role details, so it goes out for every selected college.
                // publishedIdSet holds the colleges published *before* this
                // action, so republishing never re-mails an existing college.
                // roleData is the already-fetched GET /corporates/jobs/:id
                // payload; refetch only if the parent never got it (its loader
                // returns the error response on failure, hence the tittle check).
                const roleDetails = roleData?.tittle
                  ? roleData
                  : await getRoleData(jobId)
                const jobDetailsTable = buildJobDetailsTable(roleDetails)
                const applicationDeadline = formatApplicationDeadline(
                  roleDetails?.endDate
                )
                const roleName = roleDetails?.tittle || 'Role'

                const tpoRolePayloads = []
                roleLinksData.result.forEach(college => {
                  if (publishedIdSet.has(college.instituteCampusId)) return
                  const collegeName = college.campusName || 'College'
                  college.pocDetails?.forEach(poc => {
                    if (!poc?.email) return
                    tpoRolePayloads.push({
                      to: poc.email,
                      subject: `New Job Opportunity - ${roleName} at ${companyName}`,
                      htmlBody: ReactDOMServer.renderToString(
                        <RoleShareToTPOTemplate
                          data={{
                            tpoName: poc?.name || 'Sir/Madam',
                            collegeName,
                            applicationDeadline,
                            tableData: jobDetailsTable,
                            signatureName: userName,
                            signatureContact: userPhone,
                          }}
                        />
                      ),
                    })
                  })
                })

                if (tpoRolePayloads.length > 0) {
                  dispatch(sendNotificationBulkEmail(tpoRolePayloads))
                }

                // Mark the emailed colleges as email-sent (fire and forget, no
                // await) so the Role Links page reflects the correct status.
                if (emailedCampusIds.length > 0) {
                  updateRoleLinksEmailSent(jobId, emailedCampusIds)
                }
              }
            } catch (emailErr) {
              console.error('Auto TPO email error:', emailErr)
            }

            SuccessMessage('Role floated to the institues Successfully')
            navigate('/rolePage')
          } else {
            ErrorMessage('Role publish got some issue try again')
          }
          resolve()
        },
        onClose: () => {
          setPopupConfig(null)
          resolve()
        },
      })
    })
  }
  // Modified to return a Promise for table-local loading
  const showRemoveInstitutePopup = isRemove => {
    return new Promise(resolve => {
      setPopupConfig({
        ...POPUP_CONFIGS.REMOVE_INSTITUTE,
        description: isRemove ? (
          <span>
            Are you sure want to{' '}
            <b>delete these {selectedInstitute?.length} colleges</b> from this
            group ?{' '}
          </span>
        ) : (
          <span>
            Are you sure want to{' '}
            <b>
              Add these{' '}
              {selectedColleges?.length || addToGroupSelectedIds?.length}{' '}
              colleges
            </b>{' '}
            into this group ?{' '}
          </span>
        ),
        icon: isRemove ? RedPopUp : ApprovedModelIcon,
        onApprove: async () => {
          if (groupId) {
            const payload = {
              id: groupId,
              groupName: groupName,
              instituteCampusIds: isRemove
                ? selectedInstitute
                : addToGroupSelectedIds?.length
                ? addToGroupSelectedIds
                : selectedColleges?.map(item => item?.instituteCampusId) ?? [],
              isRemove,
            }

            await removeInstituteFromGroup(payload)
            fetchGroupDetails({}, selectedGroupInstitutePagination?.currentPage)
            fetchGroupList()
          } else {
            const payload = {
              draftSelectId:
                selectedInstitute?.map(
                  item => item?.id || item?.instituteCampusId || item
                ) ?? [],
            }
            const newCollegeList = selectedColleges?.filter(
              item => !selectedInstitute?.includes(item?.instituteCampusId)
            )
            const newCollegeIdsList = selectedCollegeIds?.filter(
              item => !selectedInstitute?.includes(item)
            )

            setSelectedColleges(newCollegeList)
            setSelectedCollegeIds(newCollegeIdsList)
            setSelectedInstitute([])
            await deleteSelectedDraftInstitute(payload)
            await handleViewSelectedColleges(true, newCollegeList || [], true)
          }
          setSelectedInstitute([])
          if (!isRemove) {
            setSelectedColleges([])
            setSelectedCollegeIds([])
          }
          setAddToGroupDrawerOpen(false)
          setAddToGroupSelectedIds([])
          setAddToGroupColleges([])
          setPopupConfig(null)
          if (!isRemove) {
            handleCloseSelectedCollegesDrawer()
          }
          resolve()
        },
        onClose: () => {
          setPopupConfig(null)
          resolve()
        },
      })
    })
  }
  const showDeleteGroupPopup = groupIdPayload => {
    setPopupConfig({
      ...POPUP_CONFIGS.DELETE_GROUP,
      icon: RedPopUp,
      onApprove: async () => {
        if (groupId || groupIdPayload) {
          await deleteGroup(groupId || groupIdPayload)
        }
        setPopupConfig(null)
        setGroupCreationDrawerVisible(false)
        await fetchGroupList()
        setGroupId('')
      },
      onClose: () => setPopupConfig(null),
    })
  }
  const showDuplicatePopup = data => {
    setPopupConfig({
      ...POPUP_CONFIGS.DUPLICATE_GROUP,
      description: (
        <span>
          Are you sure you want to <b>duplicate this group</b>?
        </span>
      ),
      icon: ApprovedModelIcon,
      onApprove: async () => {
        let groupName = data?.groupName
        let groupId = data?.id || groupId
        let instituteCampusIds = data?.instituteCampusIds

        const payload = {
          groupName,
          instituteCampusIds,
        }
        await dublicateGroup(payload, groupId)
        fetchGroupList()
        setPopupConfig(null)
        setGroupId('')
        setGroupName('')
        setGroupDetails('')
        setMapMetrics({})
        setChartMetrics([])
        setSelectedInstitute([])
        setInstituteCampusList([])
        setGroupCreationDrawerVisible(false)
      },
      onClose: () => setPopupConfig(null),
    })
  }

  const updateCorpInstDetails = async (
    instituteCampusId,
    tier,
    pocDetails,
    isNotExist
  ) => {
    // Always include instituteCampusId
    const payload = { instituteCampusId }

    // Only add tier if it is not undefined/null
    if (tier !== undefined && tier !== null && tier !== 0) {
      payload.tier = tier
    }
    payload.pocDetails = pocDetails
    // Only add pocDetails if it is a non-empty array
    // if (Array.isArray(pocDetails) && pocDetails?.length > 0) {
    //   payload.pocDetails = pocDetails
    // }
    if(payload?.pocDetails === true){
      delete payload.pocDetails 
    }
    if (isNotExist) {
      await updateCorporateInstituteDetails(payload, instituteCampusId)
    } else {
      await createCorporateInstituteDetails([payload])
    }
  }

  // Handler for updating or creating corporate institute details
  const handleUpdateInstituteDetails = async (
    selectedCollege,
    tier,
    pocDetails
  ) => {
    const isTierUpdated = tier !== undefined && tier !== null
    await updateCorpInstDetails(
    selectedCollege?.instituteCampusId || selectedCollege?.id,
    tier,
    pocDetails ?? [],
    selectedCollege?.corporateDetails?.id ? true : false
  )
  if (isTierUpdated) {
    SuccessMessage('Tier updated successfully')
  }
    // if (onClose) {
    setTierDrawerOpen(false)
    setPocDrawerOpen(false)

    if (!fromGroup) {
      return await fetchCollegeList(1, 10, setLoading)
    } else {
      if (selectedCollegesDrawerMode == 'addToGroup') {
        await getDraftSelectList(1, 10)
        return await fetchAddToGroupColleges(1, 10)
      } else if (selectedCollegesDrawerMode == 'default') {
        if (groupId) {
          return await fetchGroupDetails({}, 1, 10)
        } else {
          return await getDraftSelectList(1, 10)
        }
      }
    }

    // }
  }
  const handleGroupSelect = group => {
    // Only set the selected group state, don't trigger any API calls
    setSelectedExistingGroup(group)
    setGroupName(group.groupName)
    setGroupId(group.id)
  }
  const [selectedCollegesDrawerMode, setSelectedCollegesDrawerMode] =
    useState('default')
  const [addToGroupColleges, setAddToGroupColleges] = useState([])
  const [addToGroupPageNum, setAddToGroupPageNum] = useState(1)
  const [addToGroupPageLimit, setAddToGroupPageLimit] = useState(10)
  const [addToGroupTotalItems, setAddToGroupTotalItems] = useState(0)
  const [addToGroupLoading, setAddToGroupLoading] = useState(false)
  const [addToGroupSelectedColleges, setAddToGroupSelectedColleges] = useState(
    []
  )
  const [addToGroupSelectedIds, setAddToGroupSelectedIds] = useState([])
  const [addToGroupSelectedData, setAddToGroupSelectedData] = useState([])

  const fetchAddToGroupColleges = async (
    page = 1,
    limit = 10,
    fromFilter = false,
    sortParams = {}
  ) => {
    setAddToGroupLoading(true)
    const payload = {
      cityId: selectedCollegeFilters?.selectedCities,
      stateId: selectedCollegeFilters?.selectedStates,
      tier: selectedCollegeFilters?.selectedTiers,
      pilRecommended: selectedCollegeFilters?.pilRecommended,
      search: selectedCollegeFilters?.search,
      pageLimit: limit,
      pageNo: page,
      degreeStreamMaps: degreeStreamMapIds,
      ...(sortParams.sort ? { sort: sortParams.sort } : {}),
      ...(sortParams.orderBy ? { orderBy: sortParams.orderBy } : {}),
    }
    const collegeList = await getMatchedInstituteList(payload)
    if (!fromFilter) {
      const filterResponse = await getMatchedInstituteListFilter(payload)
      setSelectedDrawerFilterData({
        states: filterResponse?.states || [],
        cities: filterResponse?.cities || [],
      })
    }
    const pagination = collegeList?.pagination
    setAddToGroupColleges(collegeList?.result || [])
    setAddToGroupTotalItems(pagination?.totalItems || 0)
    setAddToGroupPageNum(page)
    setAddToGroupPageLimit(limit)
    setAddToGroupLoading(false)
    fetchMapMetrics('', true)
  }

  const handleAddCollegeClick = async () => {
    setSelectedCollegesDrawerMode('addToGroup')
    await fetchAddToGroupColleges(1, addToGroupPageLimit)
    setAddToGroupSelectedColleges([])
    setAddToGroupSelectedIds([])
    // this is for disable checkbox for already existing college in add college to group screen
    setGroupsInstituteCampusIds(
      selectedCollegeIds?.length ? selectedCollegeIds : groupDetails?.instituteCampusIds || []
    )
    setSelectedCollegesDrawerOpen(true)
  }

  const [collegeFilters, setCollegeFilters] = useState({
    selectedTiers: [],
    selectedStates: [],
    selectedCities: [],
    search: '',
    pilRecommended: false,
    orderBy: '',
    sort: '',
  })
  const handleCollegeFilterChange = (val, key) => {
    setPageNum(1)
    setCollegeFilters(prev => {
      const updated = { ...prev, [key]: val }
      fetchCollegeList(
        1,
        pageLimit,
        setLoading,
        updated,
        collegeFilters?.search || ''
      )
      return updated
    })
  }
  const handleCollegeSearchChange = val => {
    setPageNum(1)
    setCollegeSearch(val)
    // Update filters with search value
    setCollegeFilters(prev => ({ ...prev, search: val }))
    // API call will be triggered by debounced effect
  }
  const getFilteredCollegeData = useCallback(
    data => {
      let filtered = data
      if (collegeFilters.selectedTiers.length) {
        filtered = filtered.filter(item =>
          collegeFilters.selectedTiers.includes(item.tier)
        )
      }
      // Add similar logic for states/cities if needed
      return filtered
    },
    [collegeFilters]
  )
  const defaultGroupInstListSelectedFilter = {
    selectedStates: [],
    selectedCities: [],
    selectedTiers: [],
    search: '',
    pilRecommended: false,
    sort: '',
    orderBy: '',
  }
  const [groupInstListSelectedFilter, setGroupInstListSelectedFilter] =
    useState(defaultGroupInstListSelectedFilter)

  const [selectedDrawerFilterData, setSelectedDrawerFilterData] = useState({
    states: [],
    cities: [],
    tier: [],
    pilRecommended: false,
    search: '',
  })

  // Handler for when selected colleges change in the drawer
  const handleSelectedCollegesChange = selectedRows => {
    setSelectedColleges(selectedRows)
    // if (selectedCollegesDrawerMode === 'createNewGroup') {
    handleViewSelectedColleges(false)
    // }
  }

  // Add this function to reset all group creation related state
  const resetGroupCreationState = () => {
    setGroupName('')
    setGroupId('')
    setGroupDetails('')
    setMapMetrics({})
    setChartMetrics([])
    setSelectedInstitute([])
    setInstituteCampusList([])
    setGroupsInstituteCampusIds([])
    setListData([])
    setPageNo(0)
    // Don't reset publishedCampusList here - it's used to persist the published colleges
    // banner and should remain visible across drawer open/close cycles
    setInstituteLocationList([])
    setLocationValue([])
    setTierValue([])
    setCollegesFilterData({
      location: [],
      tier: [],
    })
    setGroupBackup({})

    setSelectedGroupInstitutePagination({
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 1,
    })
    setGroupInstFilterData(prev => ({
      ...prev,
      states: [],
      cities: [],
    }))
    setGroupInstListSelectedFilter(defaultGroupInstListSelectedFilter)
  }

  // Add state/city dropdown search and refresh logic
  const [stateOptions, setStateOptions] = useState(filterData.states)
  const [cityOptions, setCityOptions] = useState(filterData.cities)

  useEffect(() => {
    setStateOptions(filterData.states)
  }, [filterData.states])
  useEffect(() => {
    setCityOptions(filterData.cities)
  }, [filterData.cities])

  const handleStateSearch = async searchText => {
    const payload = {
      degreeStreamMaps: degreeStreamMapIds,
    }
    const response = await getMatchedInstituteListFilter({
      stateSearch: searchText,
      ...payload,
    })
    setStateOptions(response?.states || [])
  }
  const handleCitySearch = async searchText => {
    const payload = {
      degreeStreamMaps: degreeStreamMapIds,
    }
    const response = await getMatchedInstituteListFilter({
      citySearch: searchText,
      ...payload,
    })
    setCityOptions(response?.cities || [])
  }
  const handleStateDropdownClose = async () => {
    const payload = {
      degreeStreamMaps: degreeStreamMapIds,
    }
    const response = await getMatchedInstituteListFilter({
      stateSearch: '',
      ...payload,
    })
    setStateOptions(response?.states || [])
  }
  const handleCityDropdownClose = async () => {
    const payload = {
      degreeStreamMaps: degreeStreamMapIds,
    }
    const response = await getMatchedInstituteListFilter({
      citySearch: '',
      ...payload,
    })
    setCityOptions(response?.cities || [])
  }

  // Add state/city/tier dropdown search and refresh logic for SelectedCollegesDrawer
  const [drawerStateOptions, setDrawerStateOptions] = useState([])
  const [drawerCityOptions, setDrawerCityOptions] = useState([])

  useEffect(() => {
    setDrawerStateOptions(selectedDrawerFilterData?.states || [])
    setDrawerCityOptions(selectedDrawerFilterData?.cities || [])
  }, [selectedDrawerFilterData])

  const handleDrawerStateSearch = async searchText => {
    let response
    if (selectedCollegesDrawerMode == 'default') {
      response = await getSelectedInstitutesFilter({
        stateSearch: searchText,
      })
    } else {
      const payload = {
        stateSearch: searchText,
        degreeStreamMaps: degreeStreamMapIds,
      }
      response = await getMatchedInstituteListFilter(payload)
    }

    setDrawerStateOptions(response?.states || [])
    setSelectedDrawerFilterData(prev => ({
      ...prev,
      states: response?.states || [],
    }))
  }
  const handleDrawerCitySearch = async searchText => {
    let response
    if (selectedCollegesDrawerMode == 'default') {
      response = await getSelectedInstitutesFilter({
        citySearch: searchText,
      })
    } else {
      const payload = {
        citySearch: searchText,
        degreeStreamMaps: degreeStreamMapIds,
      }
      response = await getMatchedInstituteListFilter(payload)
    }

    setDrawerCityOptions(response?.cities || [])
    setSelectedDrawerFilterData(prev => ({
      ...prev,
      cities: response?.cities || [],
    }))
  }
  const handleDrawerStateDropdownClose = async () => {
    let response
    if (selectedCollegesDrawerMode == 'default') {
      response = await getSelectedInstitutesFilter({})
    } else {
      const payload = {
        degreeStreamMaps: degreeStreamMapIds,
      }
      response = await getMatchedInstituteListFilter(payload)
    }
    setDrawerStateOptions(response?.states || [])
    setSelectedDrawerFilterData(prev => ({
      ...prev,
      states: response?.states || [],
    }))
  }
  const handleDrawerCityDropdownClose = async () => {
    let response
    if (selectedCollegesDrawerMode == 'default') {
      response = await getSelectedInstitutesFilter({})
    } else {
      const payload = {
        degreeStreamMaps: degreeStreamMapIds,
      }
      response = await getMatchedInstituteListFilter(payload)
    }
    setDrawerCityOptions(response?.cities || [])
    setSelectedDrawerFilterData(prev => ({
      ...prev,
      cities: response?.cities || [],
    }))
  }

  // Add state/city dropdown search and refresh logic for GroupFilters (GroupCreation)
  const [groupStateOptions, setGroupStateOptions] = useState([])
  const [groupCityOptions, setGroupCityOptions] = useState([])

  // When groupInstFilterData changes, update options
  useEffect(() => {
    setGroupStateOptions(groupInstFilterData?.states || [])
    setGroupCityOptions(groupInstFilterData?.cities || [])
  }, [groupInstFilterData])

  const handleGroupStateSearch = async searchText => {
    let response
    if (groupId) {
      response = await groupInstituteListFilter(groupId, '', searchText)
    } else {
      response = await getSelectedInstitutesFilter({
        stateSearch: searchText,
      })
    }
    setGroupStateOptions(response?.states || [])
  }
  const handleGroupCitySearch = async searchText => {
    let response
    if (groupId) {
      response = await groupInstituteListFilter(groupId, searchText, '')
    } else {
      response = await getSelectedInstitutesFilter({
        citySearch: searchText,
      })
    }
    setGroupCityOptions(response?.cities || [])
  }
  const handleGroupStateDropdownClose = async () => {
    let response
    if (groupId) {
      response = await groupInstituteListFilter(groupId)
    } else {
      response = await getSelectedInstitutesFilter()
    }
    setGroupStateOptions(response?.states || [])
  }
  const handleGroupCityDropdownClose = async () => {
    let response
    if (groupId) {
      response = await groupInstituteListFilter(groupId)
    } else {
      response = await getSelectedInstitutesFilter()
    }
    setGroupCityOptions(response?.cities || [])
  }

  return (
    <>
      {popupConfig && (
        <CloseRoleDrawer
          description={<>{popupConfig.description}</>}
          Icon={popupConfig.icon}
          showDrawer={true}
          setShowDrawer={() => setPopupConfig(null)}
          onCloseClick={popupConfig.onClose}
          onApprove={popupConfig.onApprove}
          closeText={popupConfig.closeText}
          YesText={popupConfig.yesText}
          closeButtonHeight={popupConfig.closeButtonHeight}
          closeButtonWidth={popupConfig.closeButtonWidth}
          yesButtonHeight={popupConfig.yesButtonHeight}
          yesButtonWidth={popupConfig.yesButtonWidth}
        />
      )}
      {tierDrawerOpen && (
        <TierDrawer
          open={tierDrawerOpen}
          onClose={() => setTierDrawerOpen(false)}
          initialTier={editTier}
          editingRecord={editingRecord}
          onUpdate={newTier => {
            // TODO: handle updating the tier in your data here
            setTierDrawerOpen(false)
          }}
          handleUpdate={handleUpdateInstituteDetails}
        />
      )}
      {pocDrawerOpen && (
        <POCDetailsDrawer
          open={pocDrawerOpen}
          onClose={handleCancelPOC}
          initialPOC={{
            name: '',
            number: '',
            email: '',
            isPrimary: pocList.length === 0,
          }}
          onSave={handleSavePOC}
          pocList={pocList}
          editingRecord={editingRecord}
          pocEditingIndex={pocEditingIndex}
          setPocEditingIndex={setPocEditingIndex}
          handleUpdateInstituteDetails={handleUpdateInstituteDetails}
        />
      )}
      {collegeDrawer && (
        <Drawer
          zIndex={'1001'}
          width="80%"
          padding="0px 30px"
          title={'Publish role to'}
          placement="right"
          onClose={closeHandler}
          closable={true}
          visible={collegeDrawer}
          content={content()}
          footer={null}
        />
      )}
      <PublishedCollegesDrawer
        open={publishedDrawerOpen}
        onClose={() => setPublishedDrawerOpen(false)}
        data={publishedCampusList}
      />
      <GroupCreation
        mapMetrics={mapMetrics}
        chartMetrics={chartMetrics}
        fetchMapMetrics={fetchMapMetrics}
        fetchGroupList={fetchGroupList}
        getDraftSelectList={getDraftSelectList}
        visible={groupCreationDrawerVisible}
        onClose={() => {
          setGroupCreationDrawerVisible(false)
          resetGroupCreationState()
          setGroupInstFilterData({
            states: [],
            cities: [],
            search: '',
          })
        }}
        setGroupName={setGroupName}
        groupName={groupName}
        createGroup={createGroup}
        updateGroup={updateGroup}
        deleteGroup={deleteGroup}
        setGroupDetails={setGroupDetails}
        groupDetails={groupDetails}
        selectedInstitute={selectedInstitute}
        setSelectedInstitute={setSelectedInstitute}
        oneGroupDetail={oneGroupDetail}
        removeInstituteFromGroup={removeInstituteFromGroup}
        setInstituteCampusList={setInstituteCampusList}
        instituteCampusList={instituteCampusList}
        groupId={groupId}
        handleEditTier={handleEditTier}
        handleEditPOC={handleEditPOC}
        popupConfig={popupConfig}
        setPopupConfig={setPopupConfig}
        showDeleteGroupPopup={showDeleteGroupPopup}
        showDuplicatePopup={showDuplicatePopup}
        selectedGroupPagination={selectedGroupInstitutePagination}
        handleCreateNewGroup={handleCreateNewGroup}
        setSelectedGroupInstitutePagination={
          setSelectedGroupInstitutePagination
        }
        setGroupsInstituteCampusIds={setGroupsInstituteCampusIds}
        onAddCollegeClick={handleAddCollegeClick}
        showRemoveInstitutePopup={showRemoveInstitutePopup}
        groupInstFilterData={groupInstFilterData}
        setGroupInstFilterData={setGroupInstFilterData}
        groupInstListSelectedFilter={groupInstListSelectedFilter}
        setGroupInstListSelectedFilter={setGroupInstListSelectedFilter}
        fetchGroupDetails={fetchGroupDetails}
        groupBackup={groupBackup}
        setGroupBackup={setGroupBackup}
        onPageChange={handlePageChange}
        selectedGroupInstitutePagination={selectedGroupInstitutePagination}
        groupStateOptions={groupStateOptions}
        groupCityOptions={groupCityOptions}
        onGroupStateSearch={handleGroupStateSearch}
        onGroupCitySearch={handleGroupCitySearch}
        onGroupStateDropdownClose={handleGroupStateDropdownClose}
        onGroupCityDropdownClose={handleGroupCityDropdownClose}
        selectedColleges={selectedColleges}
        handleSort={handleTableSort}
      />
      {modalVisible &&
        roleFormData?.jobDetails?.jobTypeLevel?.[0] !== 'EXPERIENCED' && (
          <CustomModal
            visible={modalVisible}
            onClose={closeModal}
            onUpdate={openModal}
            selectedCollegeCount={selectedCollegeCount}
            setSelectedCollegeCount={setSelectedCollegeCount}
            onConfirm={handlePublish}
            selectedInstituteData={selectedInstituteData}
            institutesList={institutesList}
            collagesRadio={collagesRadio}
            publishedCampusList={publishedCampusList}
          />
        )}
      {addToGroupDrawerOpen && (
        <AddToGroupDrawer
          open={addToGroupDrawerOpen}
          onClose={() => setAddToGroupDrawerOpen(false)}
          mode={addToGroupMode}
          setMode={setAddToGroupMode}
          groupList={groupData}
          fetchGroupList={fetchGroupList}
          selectedGroup={selectedExistingGroup}
          setSelectedGroup={setSelectedExistingGroup}
          onSave={() => {
            if (addToGroupMode === 'new') {
              setPopupConfig({
                ...POPUP_CONFIGS.CREATE_NEW_GROUP,
                description: (
                  <span>
                    Are you sure you want to <b>Create a new group</b>?
                  </span>
                ),
                icon: ApprovedModelIcon,
                onApprove: async () => {
                  await handleViewSelectedColleges(true)
                  // setSelectedCollegesDrawerMode('createNewGroup')
                  setGroupId('')
                  setGroupName('')
                  setAddToGroupDrawerOpen(false)
                  setGroupCreationDrawerVisible(true)
                  setPopupConfig(null)
                },
                onClose: () => setPopupConfig(null),
              })
            } else {
              handleAddToExistingGroup(selectedExistingGroup)
            }
          }}
          onGroupSelect={handleGroupSelect}
        />
      )}
      <SelectedCollegesDrawer
        handleSort={handleTableSort}
        handleUpdateInstituteDetails={handleUpdateInstituteDetails}
        editingRecord={editingRecord}
        addToGroupSelectedData={addToGroupSelectedData}
        onPageChange={handlePageChange}
        open={selectedCollegesDrawerOpen}
        onClose={handleCloseSelectedCollegesDrawer}
        selectedColleges={selectedInstitutesData}
        pageNum={selectedInstitutesPagination.currentPage}
        pageLimit={selectedInstitutesPagination.pageSize}
        totalItems={selectedInstitutesPagination.totalItems}
        setSelectedInstitute={setSelectedInstitute}
        selectedInstitute={selectedInstitute}
        setSelectedColleges={setSelectedColleges}
        onSelectedCollegesChange={handleSelectedCollegesChange}
        tableLoading={selectedDraftLoading}
        onRemoveInstitutes={(isRemove, selectedIds) => {
          if (isRemove) {
            showRemoveInstitutePopup(isRemove)
          }
          if (!isRemove && !groupId) {
            console.log('Add to Group action')
            // This is the Add to Group action
            handleAddToNewGroup()
            setSelectedCollegesDrawerOpen(false)
            // Reset filters to default state when drawer is closed
            setSelectedCollegeFilters({
              selectedTiers: [],
              selectedStates: [],
              selectedCities: [],
              pilRecommended: false,
              search: '',
            })
            return
          }
          // Use selectedIds as payload for add to group
          // Example: setGroupsInstituteCampusIds([...groupsInstituteCampusIds, ...selectedIds])
          if (!isRemove && selectedIds && groupId) {
            console.log('Add to Group action raj')
            setGroupsInstituteCampusIds([
              ...groupsInstituteCampusIds,
              ...selectedIds,
            ])
            // Call your existing logic if needed
            showRemoveInstitutePopup(isRemove)
          }
        }}
        handleEditTier={handleEditTier}
        handleEditPOC={handleEditPOC}
        groupsInstituteCampusIds={groupsInstituteCampusIds}
        mode={selectedCollegesDrawerMode}
        addToGroupColleges={addToGroupColleges}
        addToGroupPageNum={addToGroupPageNum}
        addToGroupPageLimit={addToGroupPageLimit}
        addToGroupTotalItems={addToGroupTotalItems}
        addToGroupLoading={addToGroupLoading}
        addToGroupSelectedColleges={addToGroupSelectedColleges}
        setAddToGroupSelectedColleges={setAddToGroupSelectedColleges}
        addToGroupSelectedCollegeIds={addToGroupSelectedIds}
        setAddToGroupSelectedIds={setAddToGroupSelectedIds}
        setAddToGroupSelectedData={setAddToGroupSelectedData}
        onAddToGroupDrawerPageChange={onPageChange}
        selectedDrawerFilterData={selectedDrawerFilterData}
        selectedCollegeFilters={selectedCollegeFilters}
        setSelectedCollegeFilters={setSelectedCollegeFilters}
        onFilterChange={() => {
          if (selectedCollegesDrawerMode === 'default') {
            getDraftSelectList(1, 10)
          } else if (selectedCollegesDrawerMode == 'addToGroup') {
            fetchAddToGroupColleges(1, 10, true)
          }
        }}
        // Pass state/city/tier dropdown search/refresh props
        stateOptions={drawerStateOptions}
        cityOptions={drawerCityOptions}
        onStateSearch={handleDrawerStateSearch}
        onCitySearch={handleDrawerCitySearch}
        onStateDropdownClose={handleDrawerStateDropdownClose}
        onCityDropdownClose={handleDrawerCityDropdownClose}
        chartMetrics={chartMetrics}
        mapMetrics={mapMetrics}
      />
      <LoadingOverlay visible={publishLoading} message="Publishing role..." showBackground={false} />
    </>
  )
}

export default SelectCollegesDrawer
